/** Attendance scores travel as integers in hundredths: a completed lesson is `100`, shown as `1`. */
const ATTENDANCE_SCORE_SCALE = 100

export const formatAttendanceScore = (value: number): string => String(value / ATTENDANCE_SCORE_SCALE)
